/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminRmaDisposition { 
    rmaItemId: string;
    option: AdminRmaDisposition.OptionEnum;
    newBeltRequired?: boolean;
    processId?: string;
    storageBoxNumber?: string;
}
export namespace AdminRmaDisposition {
    export const OptionEnum = {
        Refurbish: 'REFURBISH',
        Store: 'STORE',
        Dispose: 'DISPOSE'
    } as const;
    export type OptionEnum = typeof OptionEnum[keyof typeof OptionEnum];
}


export type OptionEnum = typeof AdminRmaDisposition.OptionEnum[keyof typeof AdminRmaDisposition.OptionEnum];
